module.exports = __webpack_public_path__ + "img/applyCount.61a4f633.png";